import { createAction, props } from '@ngrx/store'
import { CityCountryState } from './state.state'

// Load states for a specific country
export const loadStates = createAction('[State] Load States', props<{ countryId: string }>())

// Success action
export const loadStatesSuccess = createAction(
  '[State] Load States Success',
  props<{ states: CityCountryState[] }>()
)

// Failure action
export const loadStateFailure = createAction(
  '[State] Load State Failure',
  props<{ error: string }>()
)

export const clearStates = createAction('[State] Clear States')
